// API Configuration for hspp-gpa-reflections

// OTP Authentication Configuration
// Parameterized to allow different auth backends per environment
export const OTP_AUTH_CONFIG = {
  // HSPP-SPECIFIC: Configurable auth backend URL
  // Default to shared-ai-server, but can be overridden via environment variable
  // In production: Set VITE_OTP_AUTH_BASE_URL or REACT_APP_OTP_AUTH_BASE_URL
  BASE_URL:
    import.meta.env.VITE_OTP_AUTH_BASE_URL ||
    process.env.REACT_APP_OTP_AUTH_BASE_URL ||
    'https://sharedaiengine.apps.safegenerations.org',

  JWT_STORAGE_KEY: 'principle_canvas_jwt',  // Keep same key for shared sessions
  USER_STORAGE_KEY: 'reflection_user'       // Keep same key for shared sessions
} as const;

// Helper function to get OTP auth endpoints
export const getOTPAuthEndpoint = (path: string) => {
  return `${OTP_AUTH_CONFIG.BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
